import { useCallback, useEffect, useRef, useState } from 'react';
import { Accordion, Carousel, Image } from 'react-bootstrap';

export const ContentPreview = ({ data, type }) => {
  const itemRef = useRef(null);
  const [url, setUrl] = useState('');
  const getPicture = useCallback((file) => {
    if (typeof file === 'string') {
      // Проверяем, начинается ли путь с http, чтобы не добавлять базовый URL
      if (file.startsWith('http')) {
        return file;
      }
      return `${import.meta.env.VITE_API_URL}${file}`;
    }

    return URL.createObjectURL(new Blob([file]));
  }, []);

  useEffect(() => {
    if (data && data.type && data.type.includes('video')) {
      const url = URL.createObjectURL(data);
      setUrl(url);
    }
  }, []);

  return (
    <>
      <Accordion className="mt-3">
        <Accordion.Item eventKey={`_222`}>
          <Accordion.Header>Показать контент</Accordion.Header>
          <Accordion.Body>
            {Array.isArray(data) ? (
              <Carousel className="my-3" variant="dark">
                {data.map((i) => (
                  <Carousel.Item
                    key={`${typeof i.imgPath === 'string' ? i.imgPath : i.imgPath?.name}_${Date.now()}`}
                  >
                    <Image
                      className={'img_container w-100 d-block'}
                      src={`${getPicture(i.imgPath)}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : data.type === 'ImageContentItem' ? (
              <Image
                className={'img_container w-100 d-block'}
                src={`${getPicture(data.content)}`}
              />
            ) : type.includes('audio') || type === 'AudioContentItem' ? (
              <audio style={{ width: '100%' }} controls src={`${getPicture(data)}`} />
            ) : (
              <video style={{ width: '100%' }} ref={itemRef} controls src={url} />
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
